import Select from "@mui/material/Select"
import styled from "styled-components"
import { colors } from "../../styles/_var"


export const StyledSelect = styled(Select)`
  &.MuiInput-underline:after {
    border-bottom-color: ${colors.primary};
  }
`